<template>
    <q-page class="row">
        <div class="col-12" :class="{ 'row items-center justify-center': centered, 'layout-padding': padding }" @click="yourClickHandler">
            <slot></slot>
        </div>

        <div class="horizontal-lock footer self-end col-12" :class="lang">
            <div class="container">
                <div class="row">
                    <div class="col-md-5 col-sm-12 row">
                        <div class="col q-pt-md q-pb-xl">

                            <h3 class="q-ma-none q-pb-md q-pr-xl">{{ $T('other connections') }}</h3>

                            <ul class="footer-left-list" :class="lang+'image'">
                                <li class="q-py-md">
                                    <router-link :to="{name: 'tec'}">{{ $T("terms ans conditions") }}</router-link>
                                </li>
                                <li class="q-py-md">
                                    <router-link :to="{name: 'contact'}">{{ $T('contact us') }}</router-link>
                                </li>
                                <!--<li class="q-py-md" v-if="user">
                                    <router-link :to="{name: 'cancel-subscription'}">{{ $T('cancel') }}</router-link>
                                </li> -->

                            </ul>

                            <div class="q-mt-md q-pr-xl">
                                <!--<small>{{ $T('design by') }} Monday + {{ $T('technology by') }} PDM.</small>-->
                            </div>

                        </div>
                    </div>
                    <div class="col-7 relative-position footer-right gt-sm">
                        <div class="col row q-py-xl q-pl-xl">
                            <div class="col row wrap gutter-lg">
                                <div class="col-auto">
                                    <h6 class="q-pb-md">{{ $T("navigation") }}</h6>
                                    <ul class="footer-right-list">
                                        <li v-for="menu in userMenu">
                                            <router-link exact :to="menu.slug">
                                                {{ $T(menu.name) }}
                                            </router-link>
                                        </li>
                                    </ul>
                                </div>
                                <!--<div class="col-auto">-->
                                <!--<h6 class="q-pb-md">{{ $T('more') }}</h6>-->
                                <!--<ul class="footer-right-list">-->
                                <!--<li>-->
                                <!--<router-link :to="{name: 'contact-us'}">{{ $T('contact us') }}</router-link>-->
                                <!--</li>-->
                                <!--<li>-->
                                <!--<router-link :to="{name: 'tec'}">{{ $T('terms ans conditions') }}</router-link>-->
                                <!--</li>-->
                                <!--</ul>-->
                                <!--</div>-->
                            </div>
                            <div class="col-auto">
                                <img src="../../img/identity/kamba-logo.png" :alt="appName" class="logo-signature">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </q-page>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {loadMessages} from '../plugins/i18n'
    import {QPage, Cookies} from 'quasar-framework'
    import moment from 'moment'

    export default {
        name: 'Page',

        data: () => ({
            appName: window.config.appName,
            lang: 'lang'+window.config.locale.toUpperCase(),
        }),

        props: {
            padding: Boolean,
            centered: Boolean,
        },

        components: {
            QPage
        },

        computed: {
            ...mapGetters({
                locale: 'lang/locale',
                locales: 'lang/locales',
                user: 'auth/user',
                userMenu: 'userMenu/userMenu'
            }),

            menus() {
                return window.config.menus
            }
        },

        created() {
          window.addEventListener('beforeunload', this.$watchUser('closed'))
        },
        mounted() {
            if (!Cookies.get('locale')) {
                this.setLocale('pt')
            }
            localStorage.setItem(this.$route.path, moment(document.lastModified).format('YYYY-MM-DD HH:mm:ss'))
            if (this.lang !== 'langAR'){
                this.lang = 'langEN'
            }
        },
        beforeDestroy() {
          this.$watchUser('redirect')
        },

        methods: {
            setLocale(locale) {
              this.$q.i18n.rtl=false;
              if (this.$i18n.locale !== locale) {
                loadMessages(locale)

                this.$store.dispatch('lang/setLocale', {locale})
                this.$q.i18n.rtl = false;
              }
            },
            yourClickHandler(event) {
              let clickNow = {
                'data': Array(event.target.outerHTML),
                'date': moment(document.lastModified).format('YYYY-MM-DD HH:mm:ss')
              }
              let parsed = JSON.stringify(clickNow)
              localStorage.setItem('click', parsed)
              if (!localStorage.getItem('item'))
                this.$watchUser('click')
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .langARimage li a
        font-weight bold
        font-size 14px
        &:after
            content: "";
            display: block;
            margin: 0;
            float: right;
            background: url(../../img/caret-left.svg) no-repeat;
            width: 10px;
            height: 10px;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);

    .langAR{
        text-align: right;
    }

    .langEN{
        text-align: left;
    }
    .langENimage li a
        font-weight bold
        font-size 14px
        &:after
            content: "";
            display: block;
            margin: 0;
            float: right;
            background: url(../../img/caret-right.svg) no-repeat;
            width: 10px;
            height: 10px;
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Page.vue